import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { connect } from 'react-redux';
import EventInfo from '~/components/EventInfo';
import { getEvent } from '~/selectors/event';
const NotFoundScreen = ({ event }) => {
    return (_jsx(_Fragment, { children: _jsx(EventInfo, { eventData: event }) }));
};
const mapStateToProps = (state) => ({
    event: getEvent(state),
});
export default connect(mapStateToProps)(NotFoundScreen);
